import { Component, OnDestroy, OnInit } from "@angular/core";
import moment from "moment";
import { ConfirmationService } from "primeng/api";
import { Subscription } from "rxjs";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { LocalDataStoreService } from "src/app/core/services/local-data-store.service";
import { UserRoleEnum } from "src/app/shared/models/enums/user-role.enum";
import { Store } from "src/app/shared/models/store";
import { User } from "src/app/shared/models/user.model";

@Component({
	selector: "app-processing-status",
	templateUrl: "./processing-status.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class ProcessingStatusComponent implements OnInit, OnDestroy {
	creditPlatforms: {
		label: string;
		value: string;
	}[];
	creditPlatformSelected: string;
	creditPlatformVenues: Store[];

	moment: any = moment;

	user: User;

	singleVenueView: boolean = false;

	venues: Store[];
	venueKey: number;
	venueChangeSubscription: Subscription;

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		private localStorage: LocalDataStoreService,
		private confirmation: ConfirmationService
	) {}

	ngOnInit(): void {
		this.init();
	}

	ngOnDestroy() {
		this.venueChangeSubscription.unsubscribe();
	}

	async init() {
		this.user = await this.localStorage.get("user");
		this.venueChangeSubscription = this.localStorage.getVenue().subscribe(async (data) => {
			if (this.venueKey !== data.key) {
				this.app.loading(true);

				this.venueKey = data.key;
				await this.load();
			}
		});
		this.load();
	}

	async load() {
		if (this.user.role === UserRoleEnum.VENUEADMIN) {
			this.singleVenueView = true;
			const resp = await this.focuslink.venueGet(this.venueKey);
			this.venues = [new Store(resp)];
		}
		if (this.user.role === UserRoleEnum.DEALERADMIN) {
			await this.getVenues(this.user.dealerKey);
			await this.groupVenues(this.venues);
		}
		if (this.user.role === UserRoleEnum.SUPERADMIN || this.user.role === UserRoleEnum.GOD) {
			await this.getVenues();
			await this.groupVenues(this.venues);
		}
	}

	async getVenues(dealerKey?) {
		const resp = await this.focuslink.venueGetAll(dealerKey, true);
		this.venues = resp.map((i) => new Store(i));
	}

	async groupVenues(venues: Store[]) {
		const platformList: string[] = [];
		for (let v of venues) {
			if (!platformList.includes(v.VenueCreditStatus?.platform)) {
				platformList.push(v.VenueCreditStatus?.platform);
			}
		}
		this.creditPlatforms = [];
		platformList.forEach((i) => {
			this.creditPlatforms.push({
				label: i,
				value: i,
			});
		});
		this.creditPlatforms.sort((a, b) => (a > b ? 1 : -1));
	}

	async changePlatform() {
		this.creditPlatformVenues = this.venues.filter((i) => i.VenueCreditStatus?.platform === this.creditPlatformSelected);
		this.creditPlatformVenues.sort((a, b) => (a > b ? 1 : -1));
	}

	async toggleStateConfirm(venue: Store, state: boolean) {
		if (!state) {
			this.confirmation.confirm({
				message: `Are you sure you want to put ${venue.name} offline? Store processing will be interrupted and financial losses may result.`,
				accept: async () => {
					await this.toggleState(venue, state);
					this.app.msgSvc.add({ severity: "success", summary: "Credit Processing has been placed offline." });
				},
				reject: async () => {
					this.confirmation.close;
				},
			});
		} else {
			await this.toggleState(venue, state);
			this.app.msgSvc.add({ severity: "success", summary: "Credit Processing reenabled." });
		}
	}

	async toggleState(venue: Store, state: boolean) {
		this.app.loading(true);
		await this.focuslink.venueCreditPatch(venue.key, state);
		const v = this.venues.find((i) => i.key === venue.key);
		v.VenueCreditStatus.status = state;
		const v2 = this.creditPlatformVenues.find((i) => i.key === venue.key);
		v2.VenueCreditStatus.status = state;
		this.app.loading(false);
	}
}
